@if (isLoading) {
  <div class="spinner-container">
    <mat-spinner style="margin: auto" [diameter]="20"></mat-spinner>
    <p>Loading ... please wait</p>
  </div>
}
